import React from "react";
import "./App.css";
import "primereact/resources/themes/lara-light-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { PrimeReactProvider } from 'primereact/api';
import "primeflex/primeflex.css";
// Global UI Consistency Theme
import "./theme/styles/global.css";
import {
  HashRouter,
  Route,
  Routes,
} from "react-router-dom";
import Login from "./login/Login";

//Admin
import AdminLayout from "./layout/adminlayout/AdminLayout";
import AdminDashboard from "./admin/AdminDashboard";
import AdminDonor from "./admin/AdminDonor";
import AdminOrganiazation from "./admin/AdminOrganiazation";
import AdminFundmanager from "./admin/AdminFundmanager";
import AdminCountry from "./admin/AdminCountry";
import AdminNeeds from "./admin/AdminNeeds";
import AdminViewDonor from "./admin/AdminViewDonor";
import AdminViewOrg from "./admin/AdminViewOrg";
//layout
import AdminViewFund from "./admin/AdminViewFund";
import DonorLayout from "./layout/donorlayout/DonorLayout";
import FundManagerLayout from "./layout/fundmanagerlayout/FundManagerLayout";
import OrgLayout from "./layout/organisationlayout/OrganisationLayout";
//donor
import DonorDashboard from "./donor/DonorDashboard";
import DonorNeeds from "./donor/DonorNeeds";
import { DonorDonations } from "./donor/DonorDonation";
import { DonorDocuments } from "./donor/DonorDocuments";
import UrgentNeeds from "./donor/UrgentNeeds";
import DonorFeedback from "./donor/DonorFeedback";
import { DFundmanagerReports } from "./donor/DFundmanagerReports";
import DOrganisationReports from "./donor/DOrganizationReports";
import Mobprofile from "./mobile/Mobprofile";
import MobDash from "./mobile/MobDash";
import MobdonorDash from "./mobile/MobdonorDash";
import { MobileDonationlist } from "./mobile/MobileDonationlist";
import DOrgPrintTranscript from "./donor/DOrgPrintTranscript";
import DonorProfile from "./donor/DonorProfile";
import DFundPrintTranscript from "./donor/DFundPrintTranscript";
import { DonorAddFeedback } from "./donor/DonorAddFeedback";
import DonorChat from "./donor/DonorChat";
import NewDonation from "./donor/NewDonation";
import DonorFundManager from "./donor/DonorFundManager";
import DonorNeedsView from "./donor/DonorNeedsView";
//fundmanager
import FundDashboard from "./fundmanager/FundDashboard";
import Orgapplications from "./fundmanager/Orgapplications";
import FundDocuments from "./fundmanager/FundDocuments";
import FundFeedbacks from "./fundmanager/FundFeedbacks";
import FundDonations from "./fundmanager/FundDonations";
import MobFundDash from "./mobile/MobFundDash";
import FOrgReportsTranscript from "./fundmanager/FOrgReportsTranscript";
import FDonorReportsTranscript from "./fundmanager/FDonorReportsTranscript";
import FundViewOrg from "./fundmanager/FundViewOrg";
import FunAddFeedbacks from "./fundmanager/FunAddFeedbacks";
import FundOrganizationsReports from "./fundmanager/FundOrganizationsReports";
import FProfile from "./fundmanager/FProfile";
import DonorReports from "./fundmanager/DonorReports";
import SelectOragfantion from './fundmanager/SelectOrganization';
//orgranisation
import OrganisationDashboard from "./organisation/OrganisationDashboard";
import OrganizationNeeds from "./organisation/OrganizationNeeds";
import MobileOrgDashboard from "./mobile/MobileOrgDashboard";
import OrganizationProfile from "./organisation/OrganizationProfile";
import OrgDonorReportGenerate from "./organisation/OrgDonorReportGenerate";
import OrgFundReportGenerate from "./organisation/OrgFundReportGenerate";
import OrgViewApplication from "./organisation/OrgViewApplication";
import OrgNeedsView from "./organisation/OrgNeedsView";
import OrgEditNeeds from "./organisation/OrgEditNeeds";
import OrgAddNeeds from "./organisation/OrgAddNeeds";
import OrgApplyApplication from "./organisation/OrgApplyApplication";
import OrgSearchFundmanager from "./organisation/OrgSearchFundmanager";
import OrgAddFeedbacks from "./organisation/OrgAddFeedbacks";
import OrganizationFundmanagerReports from "./organisation/OrganizationFundmanagerReports";
import OrganizationDonorReports from "./organisation/OrganizationDonorReports";
import OrganizationApplications from "./organisation/OrganizationApplications";
import OrganizationFeedbacks from "./organisation/OrganizationFeedbacks";
import OrganizationDocuments from "./organisation/OrganizationDocuments";
import OrganizationDonations from "./organisation/OrganizationDonations";
import OrgDonarChat from './organisation/OrgDonorChat';
import { Register } from "./register/Register";
import { Forgetpassword } from "./forgetpassword/ForgetPassword";
import { RestPass } from "./resetpassword/ResetPassword";



function App() {
  return (
    <div className="App">
      <PrimeReactProvider>
        {/* <BrowserRouter basename=""> */}
        {/* <BrowserRouter basename="/Finalprod/REACT/gfn/member/"> */}
        <HashRouter>
          {/* <BrowserRouter basename={process.env.PUBLIC_URL}> */}

          {/* <Router> */}
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgetpassword" element={<Forgetpassword />} />



            {/* admin */}
            <Route path="/adashboard" element={<AdminLayout><AdminDashboard /></AdminLayout>} />
            <Route path="/donor" element={<AdminLayout><AdminDonor /></AdminLayout>} />
            <Route path="/org" element={<AdminLayout><AdminOrganiazation /></AdminLayout>} />
            <Route path="/fundmanager" element={<AdminLayout><AdminFundmanager /></AdminLayout>} />
            <Route path="/country" element={<AdminLayout><AdminCountry /></AdminLayout>} />
            <Route path="/needs" element={<AdminLayout><AdminNeeds /></AdminLayout>} />
            <Route path="/viewdonor/:donorID" element={<AdminLayout><AdminViewDonor /></AdminLayout>} />
            <Route path="/vieworg/:orgID" element={<AdminLayout><AdminViewOrg /></AdminLayout>} />
            <Route path="/viewfundmanager/:fundman_id" element={<AdminLayout><AdminViewFund /></AdminLayout>} />

            {/* donor */}
            <Route path="/ddashboard" element={<DonorLayout><DonorDashboard /></DonorLayout>} />
            <Route path="/dneeds" element={<DonorLayout><DonorNeeds /></DonorLayout>} />
            <Route path="/donations" element={<DonorLayout><DonorDonations /></DonorLayout>} />
            <Route path="/documents" element={<DonorLayout><DonorDocuments /></DonorLayout>} />
            <Route path="/urgentneeds" element={<DonorLayout><UrgentNeeds /></DonorLayout>} />
            <Route path="/feedback" element={<DonorLayout><DonorFeedback /></DonorLayout>} />
            <Route path="/fundreports" element={<DonorLayout><DFundmanagerReports /></DonorLayout>} />
            <Route path="/orgreports" element={<DonorLayout><DOrganisationReports /></DonorLayout>} />
            <Route path="/needsview/:Id/:needid" element={<DonorLayout><DonorNeedsView /></DonorLayout>} />
            <Route path="/donation/:Id/:orgID/:needtypeid" element={<DonorLayout><DonorFundManager /></DonorLayout>} />
            <Route path="/donations" element={<DonorLayout><DonorDonations /></DonorLayout>} />
            <Route path="/newdonations" element={<DonorLayout><NewDonation /></DonorLayout>} />
            <Route path="/chat/:donationID" element={<DonorLayout><DonorChat /></DonorLayout>} />
            <Route path="/addfeedback" element={<DonorLayout><DonorAddFeedback /></DonorLayout>} />
            <Route path="/printtranscript/:fundid/:rid" element={<DonorLayout><DFundPrintTranscript /></DonorLayout>} />
            <Route path="/dprofile" element={<DonorLayout><DonorProfile /></DonorLayout>} />
            <Route path="/orgprinttranscript/:fundid/:rid" element={<DonorLayout><DOrgPrintTranscript /></DonorLayout>} />
            <Route path="/mobdonationlist/:uid/:usertype/*" element={<MobileDonationlist />} />
            <Route path="/mobdonordashboard/:uid/:usertype/*" element={<MobdonorDash />} />
            <Route path="/mobdashboard/:uid/:usertype/*" element={<MobDash />} />
            <Route path="/mobprofile/:uid/:usertype/*" element={<Mobprofile />} />
            <Route path="/reset" element={<DonorLayout><RestPass /></DonorLayout>} />

            {/* fundmanager */}
            <Route path="/fdashboard" element={<FundManagerLayout><FundDashboard /></FundManagerLayout>} />
            <Route path="/orgapplications" element={<FundManagerLayout><Orgapplications /></FundManagerLayout>} />
            <Route path="/document" element={<FundManagerLayout><FundDocuments /></FundManagerLayout>} />
            <Route path="/ffeedback" element={<FundManagerLayout><FundFeedbacks /></FundManagerLayout>} />
            <Route path="/fundslist" element={<FundManagerLayout><FundDonations /></FundManagerLayout>} />
            <Route path="/donorreports" element={<FundManagerLayout><DonorReports /></FundManagerLayout>} />
            <Route path="/fprofile" element={<FundManagerLayout><FProfile /></FundManagerLayout>} />
            <Route path="/forgreports" element={<FundManagerLayout><FundOrganizationsReports /></FundManagerLayout>} />
            <Route path="/faddfeedback" element={<FundManagerLayout><FunAddFeedbacks /></FundManagerLayout>} />
            <Route path="/orgaproveapp/:application_id" element={<FundManagerLayout><FundViewOrg /></FundManagerLayout>} />
            <Route path="/fprinttranscript/:donorid/:rid" element={<FundManagerLayout><FDonorReportsTranscript /></FundManagerLayout>} />
            <Route path="/forgprinttranscript/:fundid/:rid" element={<FundManagerLayout><FOrgReportsTranscript /></FundManagerLayout>} />
            <Route path="/selectorg/:donationID" element={<FundManagerLayout>< SelectOragfantion /></FundManagerLayout>} />
            <Route path="/mobfunddashboard/:uid/:usertype/*" element={<MobFundDash />} />
            <Route path="/freset" element={<FundManagerLayout><RestPass /></FundManagerLayout>} />

            {/* organisation */}
            <Route path="/odashboard" element={<OrgLayout><OrganisationDashboard /></OrgLayout>} />
            <Route path="/orgneeds" element={<OrgLayout><OrganizationNeeds /></OrgLayout>} />
            <Route path="/receiveddonations" element={<OrgLayout><OrganizationDonations /></OrgLayout>} />
            <Route path="/odocument" element={<OrgLayout><OrganizationDocuments /></OrgLayout>} />
            <Route path="/ofeedback" element={<OrgLayout><OrganizationFeedbacks /></OrgLayout>} />
            <Route path="/oorgapplications" element={<OrgLayout><OrganizationApplications /></OrgLayout>} />
            <Route path="/donortranscript" element={<OrgLayout><OrganizationDonorReports /></OrgLayout>} />
            <Route path="/fundmanagertranscript" element={<OrgLayout><OrganizationFundmanagerReports /></OrgLayout>} />
            <Route path="/addfeedbacks" element={<OrgLayout><OrgAddFeedbacks /></OrgLayout>} />
            <Route path="/searchfundmanager" element={<OrgLayout><OrgSearchFundmanager /></OrgLayout>} />
            <Route path="/applyapplication/:fundman_id" element={<OrgLayout><OrgApplyApplication /></OrgLayout>} />
            <Route path="/addneeds" element={<OrgLayout><OrgAddNeeds /></OrgLayout>} />
            <Route path="/orgeditneeds/:Id" element={<OrgLayout><OrgEditNeeds /></OrgLayout>} />
            <Route path="/latestneedsview/:Id" element={<OrgLayout><OrgNeedsView /></OrgLayout>} />
            <Route path="/vieworgapp/:application_id" element={<OrgLayout><OrgViewApplication /></OrgLayout>} />
            <Route path="/ochat/:donationID" element={<OrgLayout><OrgDonarChat /></OrgLayout>} />
            <Route path="/oprinttranscript/:fundid/:rid" element={<OrgLayout><OrgFundReportGenerate /></OrgLayout>} />
            <Route path="/odonorprinttranscript/:donorid/:rid" element={<OrgLayout><OrgDonorReportGenerate /></OrgLayout>} />
            <Route path="/oprofile" element={<OrgLayout><OrganizationProfile /></OrgLayout>} />
            <Route path="/moborgdashboard/:uid/:usertype/*" element={<MobileOrgDashboard />} />
            <Route path="/oreset" element={<OrgLayout><RestPass /></OrgLayout>} />
          </Routes>
        </HashRouter>
      </PrimeReactProvider>
    </div>
  );
}

export default App;
